<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="menu-main"
        class="menu menu-box-right menu-box-detached rounded-m"
        data-menu-width="260"
        data-menu-effect="menu-over">
    <div class="menu-header">
      <a href="#" data-toggle-theme class="border-right-0"><i class="fa font-12 color-yellow-dark fa-lightbulb"></i></a>
      <!-- <a href="#" data-menu="menu-highlights" class="border-right-0"><i class="fa font-12 color-green-dark fa-brush"></i></a>
      <a href="#" data-menu="menu-share" class="border-right-0"><i class="fa font-12 color-red-dark fa-share-alt"></i></a> -->
      <router-link to="profile" class="border-right-0"><i class="fa font-12 color-blue-dark fa-user"></i></router-link>
      <a href="#" class="close-menu border-right-0"><i class="fa font-12 color-red-dark fa-times"></i></a>
    </div>

    <div class="menu-logo text-center">
      <a href="#"><img class="rounded-circle bg-highlight" width="80" src="images/avatars/5s.png"></a>
      <h1 class="pt-3 font-800 font-28 text-uppercase">Viliam</h1>
      <p class="font-11 mt-n2">Vyčarujte <span class="color-highlight">farebný</span> úsmev na vašej tvári.</p>
    </div>

    <div class="menu-items mb-4">
      <router-link to="home" id="nav-dashboard">
        <i data-feather="home" data-feather-line="1" data-feather-size="16" data-feather-color="blue-dark" data-feather-bg="blue-fade-light"></i>
        <span>Domov</span>
        <em class="badge bg-highlight color-white">HOT</em>
        <i class="fa fa-circle"></i>
      </router-link>
      <router-link to="database" id="nav-database">
        <i data-feather="database" data-feather-line="1" data-feather-size="16" data-feather-color="red-dark" data-feather-bg="red-fade-light"></i>
        <span>Databáza</span>
        <i class="fa fa-circle"></i>
      </router-link>
      <router-link to="orders" id="nav-orders">
        <i data-feather="file" data-feather-line="1" data-feather-size="16" data-feather-color="brown-dark" data-feather-bg="brown-fade-light"></i>
        <span>Objednávky</span>
        <i class="fa fa-circle"></i>
      </router-link>
      <router-link to="customers" id="nav-customers">
        <i data-feather="users" data-feather-line="1" data-feather-size="16" data-feather-color="green-dark" data-feather-bg="brown-fade-light"></i>
        <span>Zákazníci</span>
        <i class="fa fa-circle"></i>
      </router-link>
      <router-link to="profile" id="nav-profile">
        <i data-feather="user" data-feather-line="1" data-feather-size="16" data-feather-color="gray-light" data-feather-bg="gray-fade-light"></i>
        <span>Profil</span>
        <i class="fa fa-circle"></i>
      </router-link>
      <a href="#" class="close-menu">
        <i data-feather="x" data-feather-line="3" data-feather-size="16" data-feather-color="red-dark" data-feather-bg="red-fade-dark"></i>
        <span>Zavrieť</span>
        <i class="fa fa-circle"></i>
      </a>
    </div>

    <div class="text-center">
      <p class="mb-0 pt-3 font-10 opacity-30">Copyright <span class="copyright-year"></span> Vilten s.r.o. All rights reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainMenu',
  setup() {
    
  },
}
</script>

<style>

</style>